import { Controller } from "@hotwired/stimulus"
import { sendMarketingEvent } from "../lib/marketing_events"

export default class extends Controller {
  static values = { viewEvent: String }

  connect() {
    if (!this.hasViewEventValue) return

    const key = `munibot:event:${this.viewEventValue}`
    if (sessionStorage.getItem(key)) return

    sessionStorage.setItem(key, "1")
    this.send(this.viewEventValue, { location: window.location.pathname })
  }

  track(event) {
    this.send(event.params.event, { source: event.params.source })
  }

  send(name, properties = {}) {
    sendMarketingEvent(name, properties)
  }
}
